<div class="popover-ctn">
  @for (lang of languageList; track lang) {
    <ion-thumbnail >
      <ion-img src="/assets/flags/{{lang}}.svg" (click)="onSelect(lang)"></ion-img>
    </ion-thumbnail>
  }
</div>
